<ng-container *transloco="let t; read: 'common'">
  <div class="layout-sidebar" (click)="onMenuClick($event)">
    <div class="logo" style="text-align: center">
      <span class="app-name">{{ t('assessment_runner_administration') }}</span>
    </div>
    <nav class="layout-menu-container" role="navigation">
      <p-scrollPanel [style]="{width: '100%', height: '100%'}">
        <ul class="layout-menu" role="menubar">
          <ng-container *ngFor="let item of menuitems; let i = index;">
            <ng-container *ngIf="hasRights(item)">
              <li app-menuitem [item]="item" [index]="i" [root]="true" role="group"></li>
            </ng-container>
          </ng-container>
        </ul>
      </p-scrollPanel>
    </nav>
    <div class="version">v{{ version }}<span *ngIf="sysType !== null"> {{ sysType }}</span></div>
  </div>
</ng-container>
